import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class ExcelExecutor {
  private lastTask: Promise<void> = Promise.resolve();

  run(task: (ctx: Excel.RequestContext) => Promise<void>): Promise<void> {
    const func = async () => await Excel.run({ delayForCellEdit: true }, async ctx => await task(ctx));

    return this.lastTask = this.lastTask.then(async () => await func(), async () => await func());
  }
}
